import { observable, action } from 'mobx'

class ToolBarStore {
    @observable public showNodeDetail: boolean = false
    @observable public showLinkDetail: boolean = false
    @observable public showGraphDesc: boolean = false

    @action
    public toggleNodeDetail() {
        this.showNodeDetail = !this.showNodeDetail
    }

    @action
    public toggleLinkDetail() {
        this.showLinkDetail = !this.showLinkDetail
    }

    @action
    public clear() {
        this.showNodeDetail = false
        this.showLinkDetail = false
    }
}

export default ToolBarStore
